var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.number > 0)?_c('div',{staticClass:"SouhuoH5Sohobadge",class:(_vm.number >= 10 || _vm.needAddSymbol) ? 'normal' : 'round',domProps:{"textContent":_vm._s(_vm.showNum)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }